import { Produit } from '../../habilitation/models/produit.model';

export class SyntheseVolumesAOC {
    static jsonMap = {
        codeProduit: 'codeProduit',
        surface: 'surface',
        volumesAchats: 'volumesAchats',
        volumesVentes: 'volumesVentes',
        volumesRevendiques: 'volumesRevendiques',
        vciRevendiques: 'vciRevendiques',
        volumesDispo: 'volumesDispo',
        chgtProduitEntrees: 'chgtProduitEntrees',
        chgtProduitSorties: 'chgtProduitSorties',
        volumesTirages: 'volumesTirages',
        volumesTiragesVinDeBase: 'volumesTiragesVinDeBase',
        volumesConditionnes: 'volumesConditionnes'
    };

    codeProduit: string = undefined;

    produit: Produit;

    surface = 0;
    volumesAchats = 0;
    volumesVentes = 0;
    volumesRevendiques = 0;
    vciRevendiques = 0;
    volumesDispo = 0;
    chgtProduitEntrees = 0;
    chgtProduitSorties = 0;
    volumesTirages;
    volumesTiragesVinDeBase;
    volumesConditionnes;
}
